// // Redux/service/Snag/SnagWebSocket.js
// import { createSlice } from '@reduxjs/toolkit';

// const initialState = {
//     latestSnagEvent: null,
//     eventType: null,
// };

// const snagWebSocketSlice = createSlice({
//     name: 'snagWebSocket',
//     initialState,
//     reducers: {
//         setSnagEvent: (state, action) => {
//             state.latestSnagEvent = action.payload.data;
//             state.eventType = action.payload.eventType;
//         },
//         clearSnagEvent: (state) => {
//             state.latestSnagEvent = null;
//             state.eventType = null;
//         }
//     }
// });

// export const { setSnagEvent, clearSnagEvent } = snagWebSocketSlice.actions;
// export default snagWebSocketSlice.reducer;

// Redux/service/Snag/SnagWebSocket.js
import { createSlice } from "@reduxjs/toolkit";
import { io } from "socket.io-client";

const initialState = {
  socket: null,
  isConnected: false,
  latestSnagEvent: null,
  eventType: null,
  connectionError: null,
  reconnectAttempts: 0
};

const snagWebSocketSlice = createSlice({
  name: "snagWebSocket",
  initialState,
  reducers: {
    setSocket: (state, action) => {
      state.socket = action.payload;
    },
    setConnected: (state, action) => {
      state.isConnected = action.payload;
      if (action.payload) {
        state.reconnectAttempts = 0;
        state.connectionError = null;
      }
    },
    setSnagEvent: (state, action) => {
      console.log('🔔 Redux: Setting snag event:', action.payload);
      state.latestSnagEvent = action.payload.data;
      state.eventType = action.payload.eventType;
    },
    clearSnagEvent: (state) => {
      console.log('🧹 Redux: Clearing snag event');
      state.latestSnagEvent = null;
      state.eventType = null;
    },
    setConnectionError: (state, action) => {
      state.connectionError = action.payload;
    },
    incrementReconnectAttempts: (state) => {
      state.reconnectAttempts += 1;
    },
    resetReconnectAttempts: (state) => {
      state.reconnectAttempts = 0;
    }
  },
});

export const {
  setSocket,
  setConnected,
  setSnagEvent,
  clearSnagEvent,
  setConnectionError,
  incrementReconnectAttempts,
  resetReconnectAttempts
} = snagWebSocketSlice.actions;

// ✅ FIXED: Initialize WebSocket connection with proper event listeners
export const initializeSnagWebSocket = (token) => (dispatch) => {
  console.log('🔌 Initializing Snag WebSocket connection...');
  
  // Don't create multiple connections
  const existingSocket = window.__snagSocket__;
  if (existingSocket?.connected) {
    console.log('✅ Using existing socket connection');
    dispatch(setSocket(existingSocket));
    dispatch(setConnected(true));
    return existingSocket;
  }

  const socketUrl = process.env.REACT_APP_SOCKET_URL || 'http://localhost:4002';
  
  const socket = io(socketUrl, {
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    reconnectionAttempts: 5,
    timeout: 20000
  });

  // Store globally to prevent multiple connections
  window.__snagSocket__ = socket;

  // ✅ Connection event handlers
  socket.on('connect', () => {
    console.log('✅ Snag WebSocket connected:', socket.id);
    dispatch(setConnected(true));
    dispatch(setSocket(socket));
    dispatch(resetReconnectAttempts());
  });

  socket.on('disconnect', (reason) => {
    console.log('❌ Snag WebSocket disconnected:', reason);
    dispatch(setConnected(false));
  });

  socket.on('connect_error', (error) => {
    console.error('❌ Snag WebSocket connection error:', error.message);
    dispatch(setConnectionError(error.message));
    dispatch(incrementReconnectAttempts());
  });

  // ✅ CRITICAL: Listen to ALL snag events
  const snagEvents = [
    'snag:created',
    'snag:updated',
    'snag:resubmitted',
    'snag:rectified',
    'snag:qa_reviewed',
    'snag:consultant_reviewed'
  ];

  snagEvents.forEach(eventName => {
    socket.on(eventName, (data) => {
      console.log(`🔔 Received ${eventName}:`, data);
      
      // Extract event type from event name (remove 'snag:' prefix)
      const eventType = eventName.replace('snag:', '');
      
      dispatch(setSnagEvent({
        data: data,
        eventType: eventType
      }));
    });
  });
// ✅ Listen for general notifications (team assignments, etc.)
socket.on('notification', (data) => {
  console.log('🔔 Received notification event:', data);
  
  // Determine event type based on notification type
  let eventType = 'created';
  if (data.type === 'snag_assigned') eventType = 'created';
  else if (data.type === 'snag_updated') eventType = 'updated';
  else if (data.type === 'snag_fixed') eventType = 'fixed';
  else if (data.type === 'snag_rectified') eventType = 'rectified';
  else if (data.type === 'snag_verified') eventType = 'verified';
  else if (data.type === 'snag_closed') eventType = 'closed';
  else if (data.type === 'snag_reopened') eventType = 'reopened';
  else if (data.type === 'snag_disputed') eventType = 'disputed';
  
  dispatch(setSnagEvent({
    data: {
      id: data.id || data.snag_id,
      snag_number: data.snag_number || data.additionalData?.snag_number,
      severity: data.severity || data.additionalData?.severity,
      snag_type: data.snag_type || data.additionalData?.snag_type,
      project: data.project || { name: data.additionalData?.team_name },
      submittedBy: data.submittedBy,
      ...data
    },
    eventType: eventType
  }));
});
  // ✅ Listen for connection confirmation
  socket.on('connected', (data) => {
    console.log('✅ Socket connection confirmed:', data);
    console.log('   - User ID:', data.userId);
    console.log('   - User Role:', data.role);
    console.log('   - Projects:', data.projects);
    console.log('   - Rooms:', data.rooms);
  });

  // ✅ Listen for errors
  socket.on('error', (error) => {
    console.error('❌ Socket error:', error);
    dispatch(setConnectionError(error.message));
  });

  dispatch(setSocket(socket));
  
  return socket;
};

// ✅ Disconnect socket
export const disconnectSnagWebSocket = () => (dispatch, getState) => {
  const { socket } = getState().snagWebSocket;
  
  if (socket) {
    console.log('🔌 Disconnecting Snag WebSocket...');
    socket.disconnect();
    dispatch(setSocket(null));
    dispatch(setConnected(false));
    
    // Clear global reference
    if (window.__snagSocket__) {
      delete window.__snagSocket__;
    }
  }
};

// ✅ Manually emit event (for testing)
export const emitSnagEvent = (eventName, data) => (dispatch, getState) => {
  const { socket, isConnected } = getState().snagWebSocket;
  
  if (!socket || !isConnected) {
    console.error('❌ Cannot emit event: Socket not connected');
    return;
  }
  
  console.log(`📤 Emitting ${eventName}:`, data);
  socket.emit(eventName, data);
};

export default snagWebSocketSlice.reducer;